import { Context } from '@nuxt/types'

export default async (ctx: Context) => {
  if (!ctx.store.state.site.token) {
    await ctx.store.dispatch('nuxtServerInit', ctx)
  }
}
